import {updateObject} from "../../shared/utils/updateObject";
import * as actionTypes from "./actionTypes";
import {
    esitoCambioFormatoFilterOptionsInitialState,
    esitoCambioFormatoInitialState,
    esitoInvioEmailFilterOptionsInitialState,
    esitoInvioEmailTableDataInitialState, initialImportCambioFormato,
    initialImportCambioFormatoDistribuzione,
    initialImportDistribuzioneEsim,
    initialImportDistribuzioneEsimSostitutive,
    initialImportTagsEsim,
    initialInsertBatchAssociate,
    initialRadioButtonValueState,
    parametriESimFilterOptionsInitialState,
    parametriESimTableInitialState,
    sostitutiveListInitialState
} from "./helper";

const initialState ={
    esitoInvioEmailTableData: esitoInvioEmailTableDataInitialState,
    esitoInvioEmailFilterOptions: esitoInvioEmailFilterOptionsInitialState,
    parametriESimTableData: parametriESimTableInitialState,
    parametriESimFilterOptions: parametriESimFilterOptionsInitialState,
    importDistribuzioneEsim: initialImportDistribuzioneEsim,
    importDistribuzioneEsimSostitutive: initialImportDistribuzioneEsimSostitutive,
    distribuzioneEsimLoading: false,
    exportDistribuzioneEsimCsvLoading: false,
    esitoCambioFormatoTableData: esitoCambioFormatoInitialState,
    esitoCambioFormatoFilterOptions: esitoCambioFormatoFilterOptionsInitialState,
    cambioFormattoLoading: false,
    cambioFormatoDistribuzioneLoading: false,
    sostitutiveList: sostitutiveListInitialState,
    exportSostitutiveListCsvLoading: false,
    importCambioFormatoDistribuzione: initialImportCambioFormatoDistribuzione,
    importCambioFormato: initialImportCambioFormato,
    exportCambioFormatoLoading: false,
    exportMassiveTagsCsv: false,
    importMassiveTags: initialImportTagsEsim,
    insertBatchAssociateTags: initialInsertBatchAssociate,
    storeRadioButtonValue : initialRadioButtonValueState
}

const setEsitoInvioEmailTableData = (state, action) => {
    return updateObject(state, {
        esitoInvioEmailTableData: updateObject(state.esitoInvioEmailTableData,
            {[action.key]: action.value})
    })
}

const setEsitoInvioEmailFilterOptions = (state, action) => {
    return updateObject(state, {
        esitoInvioEmailFilterOptions: updateObject(state.esitoInvioEmailFilterOptions,
            {[action.key]: action.value})
    })
}

const setParametriESimTableData = (state, action) => {
    return updateObject(state, {
        parametriESimTableData: updateObject(state.parametriESimTableData,
            {[action.key]: action.value})
    })
}

const setParametriESimFilterOptions = (state, action) => {
    return updateObject(state, {
        parametriESimFilterOptions: updateObject(state.parametriESimFilterOptions,
            {[action.key]: action.value})
    })
}

const setEsitoCambioFormatoTableData = (state, action) => {
    return updateObject(state, {
        esitoCambioFormatoTableData: updateObject(state.esitoCambioFormatoTableData,
            {[action.key]: action.value})
    })
}

const setEsitoCambioFormatoFilterOptions = (state, action) => {
    return updateObject(state, {
        esitoCambioFormatoFilterOptions: updateObject(state.esitoCambioFormatoFilterOptions,
            {[action.key]: action.value})
    })
}

const importDistribuzioneEsim = (state, action) => {
    return updateObject(state, {
        importDistribuzioneEsim: updateObject(state.importDistribuzioneEsim, {
            [action.key]: action.value
        })
    })
}

const importDistribuzioneEsimSostitutive = (state, action) => {
    return updateObject(state, {
        importDistribuzioneEsimSostitutive: updateObject(state.importDistribuzioneEsimSostitutive, {
            [action.key]: action.value
        })
    })
}

const setDistribuzioneEsimLoading = (state, action) => {
    return updateObject(state, {distribuzioneEsimLoading: action.value});
}

const setExportDistribuzioneEsimCsvLoading = (state, action) => {
    return updateObject(state, {exportDistribuzioneEsimCsvLoading: action.value});
}

const setCambioFormatto = (state, action) => {
    return updateObject(state, {cambioFormattoLoading: action.value});
}

const setCambioFormatoDistribuzione = (state, action) => {
    return updateObject(state, {cambioFormatoDistribuzioneLoading: action.value});
}

const setSostitutiveList = (state, action) => {
    return updateObject(state, {
        sostitutiveList: updateObject(state.sostitutiveList, {
            [action.key]: action.value
        })
    })
}

const setExportSostitutiveListCsvLoading = (state, action) => {
    return updateObject(state, {exportSostitutiveListCsvLoading: action.value});
}

const importCambioFormatoDistribuzione = (state, action) => {
    return updateObject(state, {
        importCambioFormatoDistribuzione: updateObject(state.importCambioFormatoDistribuzione, {
            [action.key]: action.value
        })
    })
}

const importCambioFormatto = (state, action) => {
    return updateObject(state, {
        importCambioFormato: updateObject(state.importCambioFormato, {
            [action.key]: action.value
        })
    })
}

const setExportCambioFormatto = (state, action) => {
    return updateObject(state, {exportCambioFormatoLoading: action.value});
}

const setExportMassiveTagsCsvLoading = (state, action) => {
    return updateObject(state, {exportMassiveTagsCsv: action.value});
}

const setImportMassiveTags = (state, action) => {
    return updateObject(state, {
        importMassiveTags: updateObject(state.importMassiveTags, {
            [action.key]: action.value
        })
    })
}

const setInsertBatchAssociateTagsLoading = (state, action) => {
    return updateObject(state, {
        insertBatchAssociateTags: updateObject(state.insertBatchAssociateTags, {
            [action.key]: action.value
        })
    })
}

const setRadioButtonValue = (state, action) => {
    return updateObject(state, {storeRadioButtonValue: action.value})

}

const eSimReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_ESITO_INVIO_EMAIL_TABLE_DATA:
            return setEsitoInvioEmailTableData(state, action)
        case actionTypes.GET_ESITO_INVIO_EMAIL_FILTER_OPTIONS:
            return setEsitoInvioEmailFilterOptions(state, action)
        case actionTypes.GET_PARAMETRI_ESIM_TABLE_DATA:
            return setParametriESimTableData(state, action)
        case actionTypes.GET_PARAMETRI_ESIM_FILTER_OPTIONS:
            return setParametriESimFilterOptions(state, action)
        case actionTypes.IMPORT_DISTRIBUZIONE_ESIM:
            return importDistribuzioneEsim(state, action)
        case actionTypes.IMPORT_DISTRIBUZIONE_ESIM_SOSTITUTIVE:
            return importDistribuzioneEsimSostitutive(state, action)
        case actionTypes.DISTRIBUZIONE_ESIM:
            return setDistribuzioneEsimLoading(state, action)
        case actionTypes.EXPORT_DISTRIBUZIONE_ESIM_CSV:
            return setExportDistribuzioneEsimCsvLoading(state, action)
        case actionTypes.GET_ESITO_CAMBIO_FORMATO_TABLE_DATA:
            return setEsitoCambioFormatoTableData(state, action)
        case actionTypes.GET_ESITO_CAMBIO_FORMATO_FILTER_OPTIONS:
            return setEsitoCambioFormatoFilterOptions(state, action)
        case actionTypes.CAMBIO_FORMATO:
            return setCambioFormatto(state, action)
        case actionTypes.CAMBIO_FORMATO_DISTRIBUZIONE:
            return setCambioFormatoDistribuzione(state, action)
        case actionTypes.GET_SOSTITUTIVE_LIST:
            return setSostitutiveList(state, action)
        case actionTypes.EXPORT_SOSTITUTIVE_LIST_CSV:
            return setExportSostitutiveListCsvLoading(state, action)
        case actionTypes.IMPORT_CAMBIO_FORMATO_DISTRIBUZIONE:
            return importCambioFormatoDistribuzione(state, action)
        case actionTypes.IMPORT_CAMBIO_FORMATO_CSV:
            return importCambioFormatto(state, action)
        case actionTypes.EXPORT_CAMBIO_FORMATO_CSV:
            return setExportCambioFormatto(state, action)
        case actionTypes.EXPORT_MASSIVE_TAGS_CSV:
            return setExportMassiveTagsCsvLoading(state, action)
        case actionTypes.IMPORT_MASSIVE_TAGS_CSV:
            return setImportMassiveTags(state, action)
        case actionTypes.INSERT_BATCH_ASSOCIATE_TAGS:
            return setInsertBatchAssociateTagsLoading(state, action)
        case actionTypes.STORE_RADIO_VALUE:
            return setRadioButtonValue(state, action)
        default:
            return state;
    }
}

export default eSimReducer;
